import fdo from '@comrun/kfdo'

// Визуальный тип оплаты «QR»: в протоколе это PAYMENT_MOBILE плюс метка
// {key: PAYMENT_TYPE, value: QR} в ticketRequest.extensionOptions.auxiliary.
// На /draft метка запускает флоу Halyk QR сразу по кнопке «Продажа»
const MARKER_KEY = 'PAYMENT_TYPE'
const MARKER_VALUE = 'QR'

export default {
  computed: {
    // Компонент должен мапить configuration из store (все потребители это делают)
    halykQRConnected() {
      return !!(this.configuration && this.configuration.halykQR && this.configuration.halykQR.connected)
    },

    // HALYK_QR_ROLLOUT_GATE: видимость точек входа - подключённым всегда,
    // остальным только если БИН организации в списке HALYK_QR_CONFIG
    halykQRAvailable() {
      return this.halykQRConnected || this.$store.getters['halykQr/featureEnabled']
    },

    // Без подключённого терминала кнопка не выбирает тип оплаты, а зовёт подключиться
    qrPaymentLabel() {
      return this.halykQRConnected ? this.$t('единый_qr') : this.$t('подключить_единый_qr')
    },
  },

  created() {
    // HALYK_QR_ROLLOUT_GATE: action кэширует успешный результат - повторные вызовы дёшевы
    this.$store.dispatch('halykQr/fetchFeatureConfig')
  },

  methods: {
    // UI-тип ('PAYMENT_QR' | 'PAYMENT_CASH' | ...) -> значение протокольного enum
    toProtoPaymentType(uiType) {
      return fdo.kkm.proto.PaymentTypeEnum[uiType === 'PAYMENT_QR' ? 'PAYMENT_MOBILE' : uiType]
    },

    // Идемпотентно ставит/снимает метку QR, не трогая другие auxiliary-записи
    setQrPaymentMarker(ticketRequest, isQr) {
      if (!ticketRequest.extensionOptions) {
        if (!isQr) {
          return
        }
        ticketRequest.extensionOptions = new fdo.kkm.proto.TicketRequest.ExtensionOptions()
      }
      const auxiliary = (ticketRequest.extensionOptions.auxiliary || []).filter((kv) => kv.key !== MARKER_KEY)
      if (isQr) {
        auxiliary.push(new fdo.kkm.proto.KeyValuePair({ key: MARKER_KEY, value: MARKER_VALUE }))
      }
      ticketRequest.extensionOptions.auxiliary = auxiliary
    },

    hasQrPaymentMarker(ticketRequest) {
      return !!(ticketRequest && ticketRequest.extensionOptions && ticketRequest.extensionOptions.auxiliary
        && ticketRequest.extensionOptions.auxiliary.some((kv) => kv.key === MARKER_KEY && kv.value === MARKER_VALUE))
    },

    // from: CALCULATOR | DETAILS | INVENTORY - откуда кассир пошёл подключать терминал
    goToHalykQrSettings(from) {
      this.$store.dispatch('analytics/logEvent', { eventName: 're_halyk_qr_connect_clicked', eventProperties: { from } })
      this.$router.push('/kkm/halyk/qr')
    },
  },
}
